/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementAuditViewModel } from "../types/CourseRegistrationManagementAuditViewModel.ts";

export const courseRegistrationManagementAuditViewModelSchema = z.object({
  creationDate: z
    .string()
    .datetime()
    .describe("Data de criação do registro. Opcional.")
    .nullish(),
  creationUser: z
    .string()
    .describe("Usuário responsável pela criação do registro. Opcional.")
    .nullish(),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração do registro. Opcional.")
    .nullish(),
  lastChangeUser: z
    .string()
    .describe("Usuário responsável pela última alteração. Opcional.")
    .nullish(),
}) as unknown as ToZod<CourseRegistrationManagementAuditViewModel>;
